(function($, window, document, undefined) {

    var MultiItemCheckList = function (elem, options) {
        this.type =  null;
        this.options =  null;
        this.elem =  null;
        this.$elem = null;

        this.init('multiItemCheckList', elem, options);
    };

    MultiItemCheckList.prototype.init = function (type, elem, options) {
        this.type = type;
        this.elem = elem;
        this.$elem = $(elem);
        this.options  = options;

        this.bindEvents();
    };

    MultiItemCheckList.prototype.bindEvents = function () {
        var options = this.options;
        this.$elem.on(options.trigger + '.' + this.type, options.items, $.proxy(this.checkItems, this));
    };

    MultiItemCheckList.prototype.checkItems = function (e) {
        var options = this.options;
        var elem = $(e.target);
        var name = elem.attr('name');

        options.callback.call(this, elem, name, e);

        if (name == 'all'){
            this.checkAllItem(elem);
        } else {
            this.checkItem(elem);
        }
    };

    MultiItemCheckList.prototype.checkAllItem = function (elem) {
        var isChecked = elem.is(':checked');
        if(isChecked) {
            $(this.elem).find(this.options.items+':not(:checked)').each(function(){
                this.checked = true;
            });
        } else {
            $(this.elem).find(this.options.items+':checked').attr('checked', false);
        }
    };

    MultiItemCheckList.prototype.checkItem = function (elem) {
        var isChecked = elem.is(':checked');
        var all = $(this.elem).find(this.options.items+'[name=all]');

        if (isChecked) {
            var len = $(this.elem).find(this.options.items+':not([name="all"]):not(:checked)').length;
            if (len){
                all.attr('checked', false);
            } else {
                all.each(function(){
                    this.checked = true;
                });
            }
        } else {
            all.attr('checked', false);
        }

    };

    $.fn.multiItemCheckList = function(options) {

        return this.each(function(){
            var self = $(this);

            $.fn.multiItemCheckList.options.container = '[data-search-container="'+self.attr('id')+'"]';

            if (options && typeof options === 'string') {
                return new Error('Invalid option');
            }

            self.data('searchList', (new MultiItemCheckList(this, $.extend({}, $.fn.multiItemCheckList.options, options))));

        });
    };

    $.fn.multiItemCheckList.options =  {
        items: 'input[type="checkbox"]',
        trigger: 'click',
        isAll: true,
        callback: function(){}
    };

})(jQuery, window, document);